import React, { useState } from "react";
import * as Styled from "./styled";
import logo from "./assets/imversed-logo.svg";
import MenuDrawer from "./MenuDrawer";
import MenuIcon from "@mui/icons-material/Menu";

function MobileHeader(props) {
  const [showMenu, setShowMenu] = useState(false);

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Styled.Container>
      <Styled.Logo src={logo} onClick={() => openInNewTab("https://imversed.com/")} />
      <Styled.ButtonsContainer>
        <Styled.MenuIconButton aria-label="open menu" onClick={() => setShowMenu(true)} edge="start">
          <MenuIcon />
        </Styled.MenuIconButton>
      </Styled.ButtonsContainer>
      <MenuDrawer
        showMenu={showMenu}
        onShowMenu={(isVisible) => setShowMenu(isVisible)}
        onDisplayPopupWallet={(isVisible) => props.onDisplayPopupWallet(isVisible)}
      />
    </Styled.Container>
  );
}

export default MobileHeader;
